import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleProjectCreation(
  state: State,
  { zone, project }: Boundaries["createProject"]["success"],
): State {
  return state.map((res) =>
    res.zone.uuid === zone.uuid
      ? { ...res, projects: [project, ...res.projects] }
      : res,
  );
}

export { handleProjectCreation };
